var styles = {"wrapper":"styles_wrapper__2o8dC fixed top-0 right-0 bottom-0 left-0","loaderWrapper":"styles_loaderWrapper__KoKPH relative center"};

export default styles;
//# sourceMappingURL=styles.css.js.map
